function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import { css, color, font, spacing, StyleSheet } from "../../../styles/theme";
var CONFIG = {
  styles: {
    selected: {
      color: color.primaryTextThemeDark,
      backgroundColor: color.primary
    },
    selectedChildren: {
      color: color.primaryTextThemeDark
    }
  }
};
var DropDownListItem = /*#__PURE__*/function (_React$Component) {
  function DropDownListItem() {
    var _this;
    _classCallCheck(this, DropDownListItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DropDownListItem, [].concat(args));
    _defineProperty(_this, "handleClick", function (ev) {
      if (_this.props.onClick) {
        ev.preventDefault();
        _this.props.onClick(ev, _this.props.value);
      }
    });
    return _this;
  }
  _inherits(DropDownListItem, _React$Component);
  return _createClass(DropDownListItem, [{
    key: "getStyles",
    value: function getStyles() {
      var isDisabled = this.props.isDisabled;
      var colorStyle = isDisabled ? {
        color: color.border
      } : {};
      return StyleSheet.create({
        DropDownListItem: _objectSpread({
          'fontSize': font.sm,
          'padding': "".concat(spacing.sm, " ").concat(spacing.lg),
          ':hover': {
            cursor: isDisabled ? 'default' : 'pointer'
          }
        }, colorStyle),
        defaultHover: !isDisabled && {
          ':focus': _objectSpread({
            outline: 'none'
          }, CONFIG.styles.selected),
          ':focus *': CONFIG.styles.selectedChildren,
          ':hover': CONFIG.styles.selected,
          ':hover *': CONFIG.styles.selectedChildren
        }
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props = this.props,
        children = _this$props.children,
        label = _this$props.label;
      if (children) {
        return React.Children.map(children, function (child) {
          if (! /*#__PURE__*/React.isValidElement(child)) {
            return null;
          }

          // Don't allow focus to be set on children
          // $FlowFixMe
          return /*#__PURE__*/React.cloneElement(children, {
            tabIndex: -1
          });
        });
      }
      return label;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        htmlAttributes = _this$props2.htmlAttributes,
        isDisabled = _this$props2.isDisabled,
        value = _this$props2.value,
        onClick = _this$props2.onClick,
        rootClassName = _this$props2.rootClassName,
        style = _this$props2.style;

      // This allows rootClassName to override hover colors
      var styles = this.getStyles();
      var hoverStyles = rootClassName || styles.defaultHover;
      return /*#__PURE__*/React.createElement("li", _extends({
        role: "menuitem",
        tabIndex: isDisabled ? -1 : 0,
        value: value,
        onClick: isDisabled ? undefined : this.handleClick,
        style: style
      }, css(hoverStyles, styles.DropDownListItem), htmlAttributes), this.renderChildren());
    }
  }]);
}(React.Component);
_defineProperty(DropDownListItem, "defaultProps", {
  onClick: function onClick() {}
});
export { DropDownListItem as default };